import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImportedData } from 'lib/imported-data/ImportedData.types';
import { TranslationOptionsParams, AnchorTargetParams } from 'src/shared/shared.types';

export type E01EventDetailProps = {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & E01EventDetailParams;
  importedData: ImportedData;
};

export type E01EventDetailParams = ComponentParams & TranslationOptionsParams & AnchorTargetParams;
